import type { RootState } from "../../redux";
import { getTokenDataAction } from "../../AppSlice";
import { Subdomains, UserEndpoints } from "../../constants";
import {
  checkStatusIsraeliId,
  checkStatusRegNum,
  validateUserByIsraeliId,
  validateUserByRegNum,
} from "../../functions";
import type {
  CheckStatusDataRegNum,
  ValidateUserRegNumData,
  RegistrationPageState,
  CheckStatusDataIsraeliId,
  ValidateUserIsraeliIdData,
} from "../../types";
import { isAxiosError } from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState: RegistrationPageState = {
  registrationNumber: null,
  birthDate: "1945-01-01",
  israeliId: null,
};

export const checkStatusByRegNumAction = createAsyncThunk(
  `${Subdomains.users}${UserEndpoints.statusCheckRegNum}`,
  async (data: CheckStatusDataRegNum, { rejectWithValue }) => {
    try {
      const response = await checkStatusRegNum(data);

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) return rejectWithValue(error.response!.data.message);
      else rejectWithValue(error.message);
    }
  }
);

export const checkStatusByIsraeliIdAction = createAsyncThunk(
  `${Subdomains.users}${UserEndpoints.statusCheckIsraeliId}`,
  async (data: CheckStatusDataIsraeliId, { rejectWithValue }) => {
    try {
      const response = await checkStatusIsraeliId(data);

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) return rejectWithValue(error.response!.data.message);
      else rejectWithValue(error.message);
    }
  }
);

export const validateUserRegNumAction = createAsyncThunk(
  `${Subdomains.users}${UserEndpoints.validationByRegNum}`,
  async (data: ValidateUserRegNumData, { rejectWithValue }) => {
    try {
      const response = await validateUserByRegNum(data);

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) return rejectWithValue(error.response!.data.message);
      else rejectWithValue(error.message);
    }
  }
);

export const validateUserIsraeliIdAction = createAsyncThunk(
  `${Subdomains.users}${UserEndpoints.validationByIsraeliId}`,
  async (data: ValidateUserIsraeliIdData, { rejectWithValue }) => {
    try {
      const response = await validateUserByIsraeliId(data);

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) return rejectWithValue(error.response!.data.message);
      else rejectWithValue(error.message);
    }
  }
);

export const registrationPageSlice = createSlice({
  name: "registrationPage",
  initialState,
  reducers: {
    setRegistrationNumber: (state, { payload }: { payload: number | null }) => {
      state.registrationNumber = payload;
    },
    setIsraeliId: (state, { payload }: { payload: string | null }) => {
      state.israeliId = payload;
    },

    setBirthDate: (state, { payload }: { payload: string | null }) => {
      state.birthDate = payload;
    },

    resetRegistrationPageState: () => initialState,
  },

  extraReducers(builder) {
    builder.addCase(getTokenDataAction.fulfilled, (state, { payload }) => {
      state.registrationNumber = payload.registrationNumber;
      state.birthDate = payload.birthDate;
    });
    builder.addCase(validateUserIsraeliIdAction.fulfilled, (state, { payload }) => {
      const { registrationNumber } = payload!;
      state.registrationNumber = registrationNumber;
    });
  },
});

export const { setRegistrationNumber, setBirthDate, setIsraeliId, resetRegistrationPageState } =
  registrationPageSlice.actions;

export const selectRegistrationNumber = (state: RootState) => state.registrationPage.registrationNumber;
export const selectBirthDate = (state: RootState) => state.registrationPage.birthDate;
export const selectIsraeliId = (state: RootState) => state.registrationPage.israeliId;

export default registrationPageSlice.reducer;
